var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"centered":"","width":"80%","title":_vm.$t('create_new_product_title'),"ok-text":_vm.$t('save_button'),"cancel-text":_vm.$t('cancel_button'),"cancel-button-props":{
    props: {
      disabled: _vm.creating,
    }
  },"ok-button-props":{
    props: {
      disabled: _vm.creating,
      loading: _vm.creating
    }
  }},on:{"cancel":_vm.cancelHandler,"ok":_vm.okHandler},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{class:_vm.isMobile() ? 'flex flex-col' : 'grid grid-cols-2 gap-2'},[_c('text-input',{attrs:{"setup":{
        'func': _vm.modelSetter,
        'args': {
          'model': _vm.newProduct,
          'key': 'name',
          'prefix': 'product_'
        }
      }}}),_c('multi-currency-input',{attrs:{"setup":{
        'func': _vm.setPrice,
        'args': {
          'model': _vm.context,
          'key': 'newProduct',
          'options': _vm.currencyOptions(_vm.currencies),
          'prefix': 'price_'
        }
      }}})],1),_c('textarea-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.newProduct,
        'key': 'description',
        'prefix': 'product_'
      }
    }}}),_c('file-uploader-targets-input',{key:_vm.imgTemplate,attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': _vm.newProduct,
        'key': 'image',
        'base-api-url': 'api.presscode.app/cabinet',
        'available-mime-types': ['image/png', 'image/jpeg'],
        'prefix': 'product_',
        'targetToUpload': function () {
          return {
            'target': 'target',
            'target_id': _vm.targetId
          }
        },
      }
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }